import { useSelector } from "react-redux"
export const useSelectCountry=()=>useSelector((state) => state.DropDownValues.countryTypes)
